import { render } from "./textarea.vue?vue&type=template&id=b949ec2a"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-elements/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b949ec2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b949ec2a', __exports__)) {
    console.log('reload')
    api.reload('b949ec2a', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=b949ec2a", () => {
    console.log('re-render')
    api.rerender('b949ec2a', render)
  })

}


export default __exports__